/** */
import {
  ADD_CONTENT_JOB_SEARCH_RESULTS_TO_STORE,
  ADD_MANY_CONTENT_JOBS_TO_STORE,
  ADD_ONE_CONTENT_JOB_TO_STORE,
  LOAD_CONTENT_JOBS_TO_STORE,
  REM_ONE_CONTENT_JOB_FROM_STORE
} from '../actions/content-job';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_CONTENT_JOBS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (content_jobs, content_job) => ({
            ...content_jobs,
            [content_job.id]: content_job
          }),
          {}
        )
      };
    case ADD_ONE_CONTENT_JOB_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_CONTENT_JOB_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (content_jobs, content_job) => ({
            ...content_jobs,
            [content_job.id]: content_job
          }),
          {}
        )
      };
    case LOAD_CONTENT_JOBS_TO_STORE:
      return {
        ...payload.reduce(
          (content_jobs, content_job) => ({
            ...content_jobs,
            [content_job.id]: content_job
          }),
          {}
        )
      };
    case REM_ONE_CONTENT_JOB_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
